var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-grid"},[_c('div',{staticClass:"panel-grid__col panel-grid__col--left"},[_vm._t("left")],2),_c('div',{staticClass:"panel-grid__col panel-grid__col--right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }